import { useQuery } from "react-query";
import { useClient } from "utils/client";
import { AxiosInstance } from "axios";

interface RiskGroupingTemplate {
  id: string;
  label: string;
  description: string;
  members: string[];
}
interface RiskGroupingTemplatePayload {
  payload: RiskGroupingTemplate;
}

const fetchRiskGroupingTemplates = async (
  client: AxiosInstance
): Promise<RiskGroupingTemplate[]> => {
  const { data } = await client.get<RiskGroupingTemplatePayload[]>(
    "/risk-grouping-templates"
  );
  return data.map((item) => item.payload);
};

export const useRiskGroupingTemplates = () => {
  const client = useClient();

  const { data: templates = [], isLoading } = useQuery<RiskGroupingTemplate[]>(
    ["riskGroupingTemplates"],
    () => fetchRiskGroupingTemplates(client)
  );

  return { templates, isLoading };
};
